module.exports = __webpack_public_path__ + "img/invoice-bill-svgrepo-com.272b11d9.svg";